<style scoped>
    @import '../assets/css/loggingEvents.css';
    @import '../assets/css/common.css';
</style>
<template>
    <div>
        <div v-if="loggingEvents">
            <notification v-show="!isSmtpConfigurationEnabled" class="warning" icon-name="exclamation-triangle">
                <p> 
                    Errors will not be collected and listed until the <a :href="contextPath() + '/Settings'">SMTP configuration</a> is configured and enabled.
                </p>
            </notification>
            <div v-if="loggingEvents.length !== 0" class="logging-events-container">
                <div class="rows-container">
                    <div class="rows-container-header">
                        <div>
                            Synchronizer encountered {{loggingEvents.length}} error(s).
                        </div>
                        <input type="button" value="Clear all errors" @click="removeLoggingEvents()">
                    </div>
                    <logging-event-row :key="loggingEvent.Id" v-for="loggingEvent in loggingEvents" v-bind:loggingEvent="loggingEvent"></logging-event-row>
                </div>
            </div>
            <div class="no-logging-events" v-else>
                There are no errors.
            </div>
        </div>
        <div v-show="waitingForResponse">
            <div class="logging-events-load spinning-wheel">
                <img :src="imagePath + 'ajax-loader.gif'">
                <span>Loading...</span>
            </div>
        </div>
    </div>
</template>
<script>
    import LoggingEventRow from './loggingEventRow';
    import { mapGetters, mapActions } from 'vuex';
    import { NAMESPACE as LOGGING_EVENTS_NAMESPACE } from '../store/modules/loggingEvents.js';
    import { NAMESPACE as APP_NAMESPACE } from '../store/modules/app.js';
    import Notification from './Notification';

    export default {
        props: ['loadOnInit'],
        computed: mapGetters({
            loggingEvents: LOGGING_EVENTS_NAMESPACE.getters.LOGGING_EVENTS,
            waitingForResponse: LOGGING_EVENTS_NAMESPACE.getters.WAITING_FOR_RESPONSE,
            isSmtpConfigurationEnabled: LOGGING_EVENTS_NAMESPACE.getters.IS_SMTP_CONFIGURATION_ENABLED,
            imagePath: APP_NAMESPACE.getters.IMAGE_PATH
        }),
        methods: {
            ...mapActions({
                setUpService: LOGGING_EVENTS_NAMESPACE.actions.SET_UP_SERVICE,
                getLoggingEvents: LOGGING_EVENTS_NAMESPACE.actions.FETCH_LOGGING_EVENTS,
                removeLoggingEvents: LOGGING_EVENTS_NAMESPACE.actions.CONFIRM_DELETE_ALL
            }),
            ...mapGetters({
                contextPath: APP_NAMESPACE.getters.CONTEXT_PATH
            }),
            initComponent: async function() {
                await this.getLoggingEvents();
            }
        },
        components: {
            LoggingEventRow,
            Notification
        },
        mounted: function() {
            this.setUpService({
                prefix: this.contextPath() + '/api/profiles'
            });  
            if (this.loadOnInit === 'true') {
                this.initComponent();
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/LoggingEvents.vue